export default __webpack_public_path__ + "static/media/11.12.517f05e1.jpg";